import React from 'react'
import { motion } from 'framer-motion'
function Alert({status, alertmsg}) {
  return (
    <>
        <motion.div className='fixed top-24 right-24 z-10'>
            {status==="Success" && (
                <div className="px-4 py-2 rounded-md bg-emerald-400 shadow-md shadow-emerald-500">
                    <p className='text-lg text-primary'>{alertmsg}</p>
                </div>
            )}
        </motion.div>


        <motion.div className='fixed top-24 right-24 z-10'>
            {status==="Update" && (
                <div className="px-4 py-2 rounded-md bg-emerald-400 shadow-md shadow-emerald-500">
                    <p className='text-lg text-primary'>{alertmsg}</p>
                </div>
            )}
        </motion.div>
    </>
  )
}

export default Alert
